import pageScrollState from '../lib/page-scroll-state';
import on from '../lib/on';
import { slideToggle } from '../lib/slide-functions';
import setAttributes from '../lib/set-attributes';

// Sticky Header

const headerContainer = document.querySelector('.header-container');
const threshold = 10;

const setHeaderState = () => {
    if (window.scrollY > threshold && !headerContainer.classList.contains('sticky')) {
        headerContainer.classList.add('sticky');
    }
    if (window.scrollY <= threshold && headerContainer.classList.contains('sticky')) {
        headerContainer.classList.remove('sticky');
    }
};
setHeaderState();
window.addEventListener('scroll', setHeaderState, { passive: true });

// Desktop Nav Accessibility

const headerNavPrimary = document.querySelector('.header-nav-primary');
const itemHasChildren = [...headerNavPrimary.querySelectorAll('.menu-item-has-children')];
itemHasChildren.forEach((item, index) => {
    const link = item.querySelector('button, a:first-child');
    const subMenu = item.querySelector('.sub-menu');

    setAttributes(link, {
        'aria-expanded': 'false',
        'aria-haspopup': 'true',
        'aria-controls': `header-sub-menu-${index}`,
        id: `header-sub-menu-label-${index}`,
    });

    setAttributes(subMenu, {
        'aria-labelledby': `header-sub-menu-label-${index}`,
        id: `header-sub-menu-${index}`,
        'aria-hidden': 'true',
    });

    link.addEventListener('focus', () => {
        setAttributes(link, {
            'aria-expanded': 'true',
        });
        setAttributes(subMenu, {
            'aria-hidden': 'false',
        });
    });
    link.addEventListener('mouseenter', () => {
        setAttributes(link, {
            'aria-expanded': 'true',
        });
        setAttributes(subMenu, {
            'aria-hidden': 'false',
        });
    });
    link.addEventListener('blur', () => {
        setAttributes(link, {
            'aria-expanded': 'false',
        });
        setAttributes(subMenu, {
            'aria-hidden': 'true',
        });
    });
    link.addEventListener('mouseleave', () => {
        setAttributes(link, {
            'aria-expanded': 'false',
        });
        setAttributes(subMenu, {
            'aria-hidden': 'true',
        });
    });
});

// Desktop Burger Menu

const desktopBurgerBtn = document.querySelector('.menu-trigger-desktop');
const headerNavSecondary = document.querySelector('.header-nav-secondary');
const headerNavSecondaryLinks = [...headerNavSecondary.querySelectorAll('a')];
const headerNavSecondaryFocusTraps = [...headerNavSecondary.querySelectorAll('.focus-trap')];

headerNavSecondaryLinks.forEach((link) => {
    setAttributes(link, {
        tabindex: '-1',
    });
});
on(headerNavSecondaryFocusTraps, 'focus', () => {
    desktopBurgerBtn.focus();
});

const openDesktopMenu = () => {
    desktopBurgerBtn.classList.add('active');
    setAttributes(desktopBurgerBtn, {
        'aria-expanded': 'true',
    });
    headerNavSecondary.classList.add('active');
    headerNavSecondaryLinks.forEach((link) => {
        setAttributes(link, {
            tabindex: '0',
        });
    });
    headerNavSecondaryFocusTraps.forEach((trap) => {
        setAttributes(trap, {
            tabindex: '0',
        });
    });
    headerContainer.classList.add('opened');
    const innerWidth = () => {
        if (window.innerWidth <= 1024) {
            pageScrollState.fix();
        }
    };
    innerWidth();
};

const closeDesktopMenu = () => {
    desktopBurgerBtn.classList.remove('active');
    setAttributes(desktopBurgerBtn, {
        'aria-expanded': 'false',
    });
    headerNavSecondary.classList.remove('active');
    headerNavSecondaryLinks.forEach((link) => {
        setAttributes(link, {
            tabindex: '-1',
        });
    });
    headerNavSecondaryFocusTraps.forEach((trap) => {
        setAttributes(trap, {
            tabindex: '-1',
        });
    });
    headerContainer.classList.remove('opened');
    const innerWidth = () => {
        if (window.innerWidth <= 1024) {
            pageScrollState.unfix();
        }
    };
    innerWidth();
};

desktopBurgerBtn.addEventListener('click', () => {
    // eslint-disable-next-line no-unused-expressions
    desktopBurgerBtn.classList.contains('active') ? closeDesktopMenu() : openDesktopMenu();
});

// Mobile Menu

const mobileMenuBurgerBtn = document.querySelector('.menu-trigger-mobile');
const mobileMenuClose = document.querySelector('.mobile-menu-popup .close-btn');
const mobileItemHasChildren = document.querySelectorAll('.mobile-menu-nav .menu-item-has-children');

mobileItemHasChildren.forEach((item, index) => {
    const link = item.querySelector('.menu-mobile-item');
    const subMenu = item.querySelector('.sub-menu');

    setAttributes(link, {
        'aria-expanded': 'false',
        'aria-haspopup': 'true',
        'aria-controls': `mobile-sub-menu-${index}`,
        id: `mobile-sub-menu-label-${index}`,
    });

    setAttributes(subMenu, {
        'aria-labelledby': `mobile-sub-menu-label-${index}`,
        id: `mobile-sub-menu-${index}`,
    });

    link.addEventListener('click', (e) => {
        e.preventDefault();
        setAttributes(link, {
            'aria-expanded': 'true',
        });
        link.classList.toggle('active');
        slideToggle(subMenu);
    });
});

mobileMenuBurgerBtn.addEventListener('click', () => {
    mobileMenuBurgerBtn.classList.add('hidden');
});
mobileMenuClose.addEventListener('click', () => {
    mobileMenuBurgerBtn.classList.toggle('hidden');
});

// Open Links in New Tab

const newTabHeaderLinks = document.querySelectorAll('#menu-header-info-menu a, #menu-mobile-info-menu a');

if (newTabHeaderLinks.length > 0) {
    newTabHeaderLinks.forEach((link) => {
        setAttributes(link, {
            target: '_blank',
            'aria-label': 'Open in New Tab',
            rel: 'noopener nofollow',
        });
    });
}
